import { FC, PropsWithChildren } from 'react';
import dynamic from 'next/dynamic';
import { RECAPTCHA_V2_SITE_KEY, RECAPTCHA_V3_SITE_KEY } from '../../../constants';

const GoogleReCaptchaV2ProviderDynamic = dynamic(
	() => import('./google-re-captcha-v2-provider.component'),
	// { ssr: false }
);
const GoogleReCaptchaV3ProviderDynamic = dynamic(
	() => import('react-google-recaptcha-v3').then(mod => mod.GoogleReCaptchaProvider),
	// { ssr: false }
);

export const GoogleReCaptchaProvider: FC<PropsWithChildren> = ({ children }) => (
	<GoogleReCaptchaV2ProviderDynamic reCaptchaKey={RECAPTCHA_V2_SITE_KEY}>
		<GoogleReCaptchaV3ProviderDynamic
			reCaptchaKey={RECAPTCHA_V3_SITE_KEY}
			scriptProps={{
				async: true,
			}}
		>
			{children}
		</GoogleReCaptchaV3ProviderDynamic>
	</GoogleReCaptchaV2ProviderDynamic>
);
